/* Pretty Ballerinas - collection page: chips + load more */
(function(){
  var cfg=window.pbCol||{};
  document.body.classList.add('pb-col');
  function grid(){return document.getElementById('product-grid');}
  function placeChips(){
    var c=document.getElementById('PbChips'); if(!c) return;
    var target=document.querySelector('.collection-hero')||document.getElementById('ProductGridContainer');
    var host=document.getElementById('ProductGridContainer');
    if(host&&host.parentNode&&c.parentNode!==host.parentNode){host.parentNode.insertBefore(c,host);}
    c.hidden=false;
    var hdr=document.querySelector('.section-header');
    if(hdr&&getComputedStyle(hdr).position==='sticky') c.style.setProperty('--pb-chip-top',hdr.offsetHeight+'px');
    var on=c.querySelector('.is-on'); if(on&&on.scrollIntoView){c.querySelector('ul').scrollLeft=on.offsetLeft-20;}
  }
  var busy=false;
  function curPage(){var w=document.querySelector('.pagination-wrapper');return w?parseInt(w.dataset.page,10)||1:1;}
  function lastPage(){
    var n=1;document.querySelectorAll('.pagination__item[aria-label]').forEach(function(a){var m=(a.textContent||'').trim();var v=parseInt(m,10);if(v>n)n=v;});
    return n;
  }
  function setup(){
    var g=grid(); if(!g||!cfg.loadMore) return;
    var wrap=document.querySelector('.pagination-wrapper');
    document.querySelectorAll('.pb-more').forEach(function(e){e.remove();});
    if(!wrap) return;
    var cur=curPage(),last=lastPage();
    document.body.classList.add('pb-col-more');
    var box=document.createElement('div'); box.className='pb-more';
    box.innerHTML='<div class="pb-more__bar"><i></i></div><p class="pb-more__txt" role="status"></p><button type="button" class="pb-more__btn"></button>';
    wrap.parentNode.insertBefore(box,wrap);
    var btn=box.querySelector('button'),txt=box.querySelector('.pb-more__txt'),bar=box.querySelector('i');
    btn.textContent=cfg.moreLabel||'Load more';
    function upd(){
      var n=g.children.length;
      var t=cfg.total||n;
      txt.textContent=(cfg.shown||'You have seen [n] of [t] pieces').replace('[n]',Math.min(n,t)).replace('[t]',t);
      bar.style.width=Math.min(100,n/t*100)+'%';
      if(cur>=last) box.style.display='none';
    }
    upd();
    btn.addEventListener('click',function(){
      if(busy||cur>=last) return; busy=true; btn.disabled=true;
      var u=new URL(location.href); u.searchParams.set('page',cur+1);
      fetch(u.toString()).then(function(r){return r.text();}).then(function(h){
        var d=new DOMParser().parseFromString(h,'text/html'),ng=d.getElementById('product-grid');
        if(ng){Array.prototype.slice.call(ng.children).forEach(function(li,i){li.classList.add('pb-col-new');li.style.animationDelay=(i*40)+'ms';g.appendChild(document.importNode(li,true));});}
        cur++; history.replaceState(null,'',u.toString()); upd();
      }).catch(function(){location.href=u.toString();}).then(function(){busy=false;btn.disabled=false;});
    });
  }
  function clampDesc(){
    var d=document.querySelector('.collection-hero__description');
    if(!d||d.dataset.pbClamp) return; d.dataset.pbClamp='1';
    if(d.scrollHeight<=96) return;
    d.classList.add('pb-clamp');
    var b=document.createElement('button'); b.type='button'; b.className='pb-clamp__btn'; b.textContent=cfg.readMore||'Read more';
    b.addEventListener('click',function(){var o=d.classList.toggle('is-open');b.textContent=o?(cfg.readLess||'Show less'):(cfg.readMore||'Read more');});
    d.parentNode.insertBefore(b,d.nextSibling);
  }
  function boot(){placeChips();setup();clampDesc();}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  /* re-run after Dawn filters/sort re-render the grid */
  var c=document.getElementById('ProductGridContainer');
  if(c){new MutationObserver(function(){ if(!document.querySelector('.pb-more')) setup(); }).observe(c,{childList:true,subtree:false});}
  document.addEventListener('shopify:section:load',boot);
})();
